import { useMemo } from 'react';
import { useDataQueryResult } from '@/plugin-system';
import { TimeSeriesChartProps } from '../time-series-chart-model';

/**
 * Hook to get thresholds from query results if they exist. If not, use thresholds from panel spec.
 * TODO: Combine the results since right now we only support thresholds from one query.
 */
export function useDataThresholds(thresholds: TimeSeriesChartProps['thresholds']): TimeSeriesChartProps['thresholds'] {
  const { queryResults } = useDataQueryResult({ dataTypeFilter: 'TimeSeries' });
  return useMemo(() => {
    const q = queryResults.find((result) => {
      return result.data?.metadata?.thresholds;
    });
    return q?.data?.metadata?.thresholds ?? thresholds;
  }, [queryResults, thresholds]);
}
